.AppCrashed {
  width: 100%;
  height: 100%;

  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;

  p {
    font-size: .8rem;
    text-align: center;
  }

  .line {
    display: flex;
    flex-direction: column;
    row-gap: .5rem;
  }

  .card {
    min-width: 60rem;
    min-height: 20rem;
    max-height: 80vh;

    overflow: scroll;
    
    padding: 3rem;

    display: flex;
    flex-direction: column;
    align-items: center;

    row-gap: 2rem;

    text-align: center;
  }

  .detail {
    cursor: pointer;
  }

  .error {
    margin: 0;
    row-gap: 0;
  }

  .stackTrace {
    color: black;
    white-space: pre-wrap;
    text-align: left;
    font-size: 1rem;
  }
  
}